const urlCreator = (baseUrl, queryParamObject) => {
  const searchParams = new URLSearchParams(queryParamObject).toString()
  return searchParams.length > 0 ? `${baseUrl}?${searchParams}` : baseUrl
}

export { urlCreator }
